import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

import { IntegrationsSubSection, IntegrationTabStructure } from '../../interface/integrationmodal.interface';
import { IntegrationRecord } from '../../models/integrations/integrationrecord.class';
import { MasterTables } from '../../models/masters/mastertables.class';
import { IntegrationsUtilsService } from '../../services/integrations-utils/integrations-utils.service';

@Component({
    selector: 'app-integrations-postman-structure',
    templateUrl: './integrations-postman-structure.component.html',
    styleUrls: ['./integrations-postman-structure.component.scss'],
    standalone: false,
})
export class IntegrationsPostmanStructureComponent implements AfterViewInit {
    @Input() subSection: IntegrationsSubSection;
    @Input() record: IntegrationRecord;
    @Input() hideField: (...args: any[]) => boolean;
    @Input() subSectionRecord: IntegrationsSubSection['records'][0];
    @Input() masterTableColumns: any;
    @Input() masterTables: MasterTables[];
    @Input() subTenants: any[];
    @Input() sources: { id: string; displayName: string; value?: string | boolean; pushValue?: string }[] = [];
    @Input() readonly = false;

    @Output() checkValidateButton = new EventEmitter<boolean>();

    setAsActiveTab = this._integrationUtils.setAsActiveTab;

    isTabDisabled = (tab: IntegrationTabStructure) => {
        return this._integrationUtils.isTabDisabled(tab, this.record, this.subSection.tabs, this.subSectionRecord);
    };

    addNewTabRecord = (currentTab: IntegrationTabStructure) => this._integrationUtils.addNewTabRecord(currentTab, this.record);

    constructor(private _integrationUtils: IntegrationsUtilsService) {}

    ngAfterViewInit() {}
}
